import { useState, useEffect } from 'react';
import { FindIdPage } from './auth/FindIdPage';
import { DesktopFindIdPage } from './desktop/DesktopFindIdPage';

export function ResponsiveFindIdPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <FindIdPage /> : <DesktopFindIdPage />;
}